import { Injectable } from '@angular/core';
import { Survey } from './shared/model-service';

@Injectable({
  providedIn: 'root'
})
export class SurveyAnswerService {

  constructor() { }

  OnEditRemoveResult(survey: any, index)
  {
    var removed = survey.questions.slice(index)

    removed.forEach(element => {
      element.result  = null
    });
  }

  /**
   * GetAnswerDto
   */
  getAnswerDto(survey: any) {
    var answerDto = {};
    console.log('Service doit sauver', survey);
    return answerDto;
  }
}
